import gql from "graphql-tag";

export const GET_PROFILE = gql`
  query profileForHeader {
    profile {
      userId,
      name
    }
  }
`;

export const GET_USER = gql`
  query user($userId:String!) { 
    user(userId: $userId) {
      userId
      name
      email
      status
      auth0 {
        createdAt
        emailVerified
        lastLogin
        lastPasswordReset
        loginsCount
        updatedAt
        lastIp
      }
    }
  }
`;

export const LIST_USERS = gql`
  query users { 
    users { 
      userId
      name
      email
      status
    }
  }
`;

export const ON_NEW_USER = gql`
  subscription {
    newUser { 
      userId
      name
      email
      status
    }
  }
`;
